<template>
  <v-dialog v-model="show"   max-width="500">
      <v-card>
        <v-card-title>
        {{ title }}
        </v-card-title>
        <v-container class="px-6">
          <v-text-field
            outlined
            label="Title"
            v-model="form.header"
            :error-messages="form.$getError('header')">
          </v-text-field>

          <v-text-field
            outlined
            label="Sub Title"
            v-model="form.sub_header"
            :error-messages="form.$getError('sub_header')">
          </v-text-field>

          <v-text-field
            outlined
            label="Signup URL"
            v-model="form.affiliate_link"
            :error-messages="form.$getError('affiliate_link')">
          </v-text-field>

          <v-checkbox
            class="mt-0"
            label="Best Promo"
            v-model="form.best_promo_flag"
          ></v-checkbox>

          <v-checkbox
            class="mt-0"
            label="Welcome Promo"
            v-model="form.welcome_promo_flag"
          ></v-checkbox>

          <v-card-actions >
            <v-spacer></v-spacer>
            <v-btn text class="text-transform-none" @click="show = false">Cancel</v-btn>
            <v-btn class="text-transform-none" color="primary" @click="success">{{ successText }}</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
  </v-dialog>
</template>
<script>
import Form from '@/utils/form'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Promo'
    },
    successText: {
      type: String,
      default: 'Add'
    },
    promo: {
      type: Object,
      default () {
        return { }
      }
    }
  },
  data () {
    return {
      show: this.value,
      form: new Form({
        header: null,
        sub_header: null,
        affiliate_link: null,
        best_promo_flag: null,
        welcome_promo_flag: null,
        ...this.promo
      })
    }
  },
  watch: {
    value (val) {
      this.form.$reset()
      this.show = val
    },

    show (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    success () {
      this.form.$clearErrors()
      this.validate()
      if (!this.form.$hasErrors()) {
        this.show = false
        this.$emit('success', this.form.$data())
      }
    },
    validate () {
      if (this.form.header === null || this.form.header.trim() === '') {
        this.form.$setError('header', 'The title is required')
      }

      if (this.form.sub_header === null || this.form.sub_header.trim() === '') {
        this.form.$setError('sub_header', 'The sub title is required')
      }

      if (this.form.affiliate_link === null || this.form.affiliate_link.trim() === '') {
        this.form.$setError('affiliate_link', 'The url is required')
      }

      if (this.form.affiliate_link !== null && !this.validURL(this.form.affiliate_link)) {
        this.form.$setError('affiliate_link', 'The url is invalid')
      }
    },
    validURL (str) {
      let pattern = new RegExp('^(https?:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
      return !!pattern.test(str)
    }
  }

}
</script>
